window['$'] = window['jQuery'] = require("../../../static/js/jquery/jquery-1.12.4.min.js");
require("../../../static/js/jquery/jquery.browser.min.js");
require("../../../static/plugins/bootstrap/3.3.6/js/bootstrap.min.js");
window['Spinner'] = require("../../../static/js/spin.min.js");
require("../../../static/au/js/spinner.js");
require("../../../static/au/js/main_etf.js");
require("../../../static/au/js/global-nav.js");
